import { b as h, A as n, n as s, t as d } from "./element-CV9utnHJ.js";
import { r as k } from "./state-l4hGZdFJ.js";
import { P as f } from "./input-element-BGNbdzy2.js";
import { e as g, n as b } from "./ref-Dma3n3i8.js";
import { e as u } from "./class-map-3ADKve8g.js";
var y = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, i = (e, a, c, l) => {
  for (var p = l > 1 ? void 0 : l ? $(a, c) : a, r = e.length - 1, o; r >= 0; r--)
    (o = e[r]) && (p = (l ? o(a, c, p) : o(p)) || p);
  return l && p && y(a, c, p), p;
};
let t = class extends f {
  constructor() {
    super(...arguments), this.inputRef = g(), this.value = "", this.checkHelptext = null, this.defaultChecked = !1, this.hasTile = !1, this.checked = null, this.type = "radio", this.tagText = null, this.optionalTag = !1, this.optionalText = "Valgfritt", this.requiredTag = !1, this.requiredText = "Må fylles ut", this._checked = !1;
  }
  connectedCallback() {
    super.connectedCallback();
  }
  attributeChangedCallback(e, a, c) {
    e === "defaultChecked" && (this._checked = this.defaultChecked), e === "checked" && (this._checked = this.checked === "" || this.checked === "true" || this.checked === !0), super.attributeChangedCallback(e, a, c);
  }
  render() {
    const e = u({
      "pkt-input-check__input": !0,
      "pkt-input-check__input--tile": this.hasTile,
      "pkt-input-check__input--tile-disabled": this.disabled && this.hasTile
    }), a = u({
      "pkt-input-check__input-checkbox": !0,
      "pkt-input-check__input-checkbox--error": this.hasError
    }), c = u({
      "pkt-input-check__input-label": !0,
      "pkt-input-check__input-label--disabled": this.disabled,
      "pkt-sr-only": this.hideLabel
    }), l = "pkt-tag pkt-tag--small pkt-tag--thin-text", p = () => h`
        ${this.tagText ? h`<span class=${l + " pkt-tag--gray"}>${this.tagText}</span>` : n}
        ${this.optionalTag ? h`<span class=${l + " pkt-tag--blue-light"}>${this.optionalText}</span>` : n}
        ${this.requiredTag ? h`<span class=${l + " pkt-tag--beige"}>${this.requiredText}</span>` : n}
      `, r = () => h`
        <label class=${c} for=${this.id + "-internal"}>
          ${this.label} ${p()}
          ${this.checkHelptext ? h`<div class="pkt-input-check__input-helptext">${this.checkHelptext}</div>` : n}
        </label>
      `;
    return h`
      <div class="pkt-input-check">
        <div class=${e}>
          <input
            id=${this.id + "-internal"}
            class=${a}
            type="radio"
            role="radio"
            ?disabled=${this.disabled}
            form=""
            name=${this.name + "-internal"}
            ${b(this.inputRef)}
            @change=${this.toggleChecked}
            @input=${this.onInput}
            @blur=${this.onBlur}
            @focus=${this.onFocus}
            ?checked=${this.checked}
          />
          ${r()}
        </div>
      </div>
    `;
  }
  toggleChecked(e = null) {
    e && e.preventDefault(), e && e.stopImmediatePropagation(), this.touched = !0, this.inputRef.value && (this._checked = this.inputRef.value.matches(":checked"), this.valueChecked(this._checked));
  }
};
i([
  s({ type: String, reflect: !0 })
], t.prototype, "value", 2);
i([
  s({ type: String })
], t.prototype, "checkHelptext", 2);
i([
  s({ type: Boolean })
], t.prototype, "defaultChecked", 2);
i([
  s({ type: Boolean })
], t.prototype, "hasTile", 2);
i([
  s({ type: Boolean, reflect: !0 })
], t.prototype, "checked", 2);
i([
  s({ type: String, reflect: !0 })
], t.prototype, "type", 2);
i([
  s({ type: String })
], t.prototype, "tagText", 2);
i([
  s({ type: Boolean })
], t.prototype, "optionalTag", 2);
i([
  s({ type: String })
], t.prototype, "optionalText", 2);
i([
  s({ type: Boolean })
], t.prototype, "requiredTag", 2);
i([
  s({ type: String })
], t.prototype, "requiredText", 2);
i([
  k()
], t.prototype, "_checked", 2);
t = i([
  d("pkt-radiobutton")
], t);
export {
  t as P
};
